import TagsDirectSaleList from '@/components/Settings/Profiles/TagsDirectSale/TagsDirectSaleList';
import TagsDirectSaleModal from '@/components/Settings/Profiles/TagsDirectSale/TagsDirectSaleModal';
import { useDisclosure, useWindowSize } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Button, Typography } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function TagsDirectSalePage({ route }: PageProps) {
  const intl = useIntl();
  const { Title, Paragraph } = Typography;
  const { width } = useWindowSize();

  const [modalOpened, modalActions] = useDisclosure();

  return (
    <>
      <div className="page">
        <Helmet title={intl.formatMessage({ id: route.name })} />
        <div className="page-header">
          <Title level={4}>{intl.formatMessage({ id: route.name })}</Title>

          {!(width < 992) && (
            <Button type="primary" onClick={modalActions.open}>
              Criar Etiqueta
            </Button>
          )}
        </div>

        <Paragraph style={{ marginTop: '16px' }}>
          Etiquetas responsáveis para você identificar suas vendas diretas da
          forma que desejar!
        </Paragraph>

        <TagsDirectSaleList />
      </div>

      <TagsDirectSaleModal open={modalOpened} onCancel={modalActions.close} />
    </>
  );
}
